module.exports = __webpack_public_path__ + "static/media/Rathalos.b70ae271.png";


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images/Rathalos.png
// module id = 134
// module chunks = 0